import IconTriangleDown from "assets/img/icon-triangle-down.svg?react"

import { FC, useState, ReactNode, useEffect } from "react"
import { useTranslation } from "react-i18next"

import Button from "components/Button/Button"
import AssetVersion from "models/AssetVersion"
import { printPeriod } from "utils/utils"
import Spinner from "components/Spinner/Spinner"

interface IVersionCollapsibleProps {
    version: AssetVersion
    defaultExpanded?: boolean
    children: ReactNode | ((isExpanded: boolean) => ReactNode)
    isLoading?: boolean
    className?: string
}

const VersionCollapsible: FC<IVersionCollapsibleProps> = ({
    version,
    defaultExpanded = false,
    children,
    isLoading = false,
    className = "",
}) => {
    const { t } = useTranslation()
    const [isExpanded, setIsExpanded] = useState(defaultExpanded)

    useEffect(() => {
        setIsExpanded(defaultExpanded)
    }, [defaultExpanded])

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded)
    }

    // Show version number with date range (only used for previous versions now)
    const versionLabel = `${t('asset.version')} ${version.version}: ${printPeriod({ start: version.availabilityDate, end: version.disposalDate })}`

    return (
        <div className={`border-bottom-grey-100 ${className}`}>
            <div className="py-2">
                <Button
                    theme="link"
                    label={versionLabel}
                    icon={
                        <div style={{ transform: isExpanded ? 'none' : 'rotate(-90deg)', transition: 'transform 0.2s ease' }}>
                            <IconTriangleDown />
                        </div>
                    }
                    iconPosition="start"
                    size="small"
                    onClick={toggleExpanded}
                    className="text-left color-black font-bold"
                />
            </div>
            {isExpanded && (
                <div className="pb-4 pl-4 ml-2 border-left-grey-200">
                    {isLoading ? (
                        <Spinner className="py-4" />
                    ) : (
                        typeof children === 'function' ? children(isExpanded) : children
                    )}
                </div>
            )}
        </div>
    )
}

export default VersionCollapsible
